<template>
  <el-pagination
      class="table-pagination"
      :page-size="pageSize"
      :pager-count="pagerCount"
      @current-change="changePage"
      :current-page="currentPage"
      layout="prev, pager, next"
      background
      :total="totalCount">
  </el-pagination>
</template>
<script>
import {mapState} from 'vuex'
import {actionTypes as adminActions} from "@/store/modules/admin"

export default {
  props: ['pageSize', 'totalCount', 'pagerCount'],
  computed: {
    ...mapState({
      currentPage: state => state.admin.page
    })
  },
  methods: {
    changePage(page) {
      this.$store.dispatch(adminActions.setPage, {page})
      this.$emit('page-switched')
    },
  }
}
</script>